import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { firestore } from "../../index";
import {
  defaultDexcoMembers,
  DexcoMember,
  normalizeDexcoMember,
  sortDexcoMembers,
} from "./dexco_data";

export default function useDexcoMembers() {
  const [members, setMembers] = useState<DexcoMember[]>(defaultDexcoMembers);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDexcoMembers() {
      try {
        const snapshot = await getDocs(collection(firestore, "dexco_members"));

        if (!snapshot.docs.length) {
          setMembers(defaultDexcoMembers);
          return;
        }

        setMembers(
          sortDexcoMembers(
            snapshot.docs.map((memberDoc) =>
              normalizeDexcoMember({
                docId: memberDoc.id,
                ...(memberDoc.data() as Omit<DexcoMember, "docId">),
              }),
            ),
          ),
        );
      } catch (error) {
        console.error("Failed to load dexco members", error);
        setMembers(defaultDexcoMembers);
      } finally {
        setLoading(false);
      }
    }

    fetchDexcoMembers();
  }, []);

  return {
    members,
    loading,
  };
}
